import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'dayjs',
  standalone: true
})
export class DayjsPipe implements PipeTransform {

  public transform(value: string): dayjs.Dayjs {
    return dayjs(value);
  }
}
